import { request } from '../axios/request';
import {
  FETCH_HOME_WIDGET_FULFILLED,
  FETCH_HOME_WIDGET_REJECTED,
  FETCH_HOME_WIDGET_PENDING,
} from '../constants/homeWidget';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const homeWidgetFulfilled = (response) => ({
  type: FETCH_HOME_WIDGET_FULFILLED,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_HOME_WIDGET_REJECTED,
  error: error,
});

const pending = () => ({
  type: FETCH_HOME_WIDGET_PENDING,
});

export const fetchHomeWidget = () => (dispatch, getState) => {
  dispatch(pending());
  request({
    method: 'get',
    url: `${$U.INSTORE_WIDGETS}`,
  })
    .then((response) => {
      dispatch(homeWidgetFulfilled(response.data.attributes.element));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/homeWidget.js